import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class TablesFetchAPI {
    //Function to get the branchoffice tables 
    static async getBranchofficeTables(branchoffice_id, token) {
        const res = await server(`/tables/${branchoffice_id}/branchoffice?is_archived=false`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to get the business tables 
    static async getBusinessTables(business_id, token) {
        const res = await server(`/tables/${business_id}/business`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to delete a table 
    static async deleteTable(table_id, token) {
        const res = await server(`/table/${table_id}`, {
            method: "delete",
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to create a table
    static async createTable(data, token) {
        const res = await server(`/tables`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to update a table
    static async updateTable(table_id, data, token) {
        const res = await server(`/table/${table_id}`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to get temp orders by table id
    static async getTempOrdersByTableId(table_id, token) {
        const res = await server(`/temp/table/order/${table_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to get the environments objects by branchoffice id
    static async getEnvironmentsObjectsByBranchofficeId(branchoffice_id, token) {
        const res = await server(`/tables/environment/objects/${branchoffice_id}/branchoffice`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to create an environment object
    static async createEnvironmentObject(data, token) {
        const res = await server(`/tables/environment/objects`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to update an environment object
    static async updateEnvironmentObject(object_id, data, token) {
        const res = await server(`/tables/environment/object/${object_id}`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to delete an environment object
    static async deleteEnvironmentObject(object_id, token) {
        const res = await server(`/tables/environment/object/${object_id}`, {
            method: "delete",
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to get table dinners 
    static async getTableDinners(table_id, token) {
        const res = await server(`/tables/${table_id}/diners`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to add table dinners 
    static async addTableDinners(table_id, data, token) {
        const res = await server(`/tables/${table_id}/diners`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to delete a table dinner 
    static async deleteTableDinner(table_id, dinner_id, token) {
        const res = await server(`/tables/${table_id}/diners/${dinner_id}`, {
            method: "delete",
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to update a table dinner 
    static async updateTableDinner(table_id, dinner_id, data, token) {
        const res = await server(`/tables/${table_id}/diners/${dinner_id}`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to assign items to a table diner
    static async assignItemsToDiner(table_id, data, token) {
        const res = await server(`/tables/${table_id}/diners/assign-items`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to unassign items from a table diner
    static async removeItemsFromDiner(table_id, data, token) {
        const res = await server(`/tables/${table_id}/diners/unassign-items`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }
}